/**
 * Практический ориентир для трекера: 30 мл на килограмм массы тела.
 * Это не медицинская рекомендация; округление до 50 мл не создаёт ложной
 * точности. Ограничения защищают интерфейс от крайних значений анкеты.
 */
export function waterGoalMl(profile) {
    const estimate = profile.weightKg * 30;
    return Math.max(1_500, Math.min(4_000, Math.round(estimate / 50) * 50));
}
const WATER_WORD = /(?<!\p{L})вод(?:а|ы|у|ой|е|ичк(?:а|и|у|ой|е))(?!\p{L})/iu;
const GLASS = /стакан(?:а|ов)?|стаканчик(?:а|ов)?|чашк(?:а|и|у)|кружк(?:а|и|у)/iu;
/** Распознаёт отдельную запись о чистой воде. null — это не запись воды. */
export function parseWaterIntake(text) {
    const normalized = text.toLowerCase().replace(/ё/g, 'е')
        .replace(/(?<!\d)[.,]|[.,](?!\d)|[!?;:()«»"']/g, ' ').replace(/\s+/g, ' ').trim();
    if (!WATER_WORD.test(normalized))
        return null;
    // Не перехватываем блюда и напитки, где вода лишь часть описания.
    const remainder = normalized
        .replace(WATER_WORD, ' ')
        .replace(/(?<!\p{L})(?:я|выпил(?:а)?|пил(?:а)?|пью|добавь|добавил(?:а)?|запиши|записал(?:а)?|еще|примерно|около)(?!\p{L})/giu, ' ')
        .replace(new RegExp(String.raw `(?<![\p{L}\d])\d+(?:[.,]\d+)?\s*(?:мл|миллилитр\p{L}*|л|литр\p{L}*|${GLASS.source})(?!\p{L})`, 'giu'), ' ')
        .replace(new RegExp(String.raw `(?<!\p{L})(?:${GLASS.source})(?!\p{L})`, 'giu'), ' ')
        .replace(/\s+/g, ' ').trim();
    if (remainder)
        return null;
    const volume = normalized.match(/(\d+(?:[.,]\d+)?)\s*(мл|миллилитр\p{L}*|л|литр\p{L}*)(?!\p{L})/iu);
    if (volume) {
        const amount = Number(volume[1].replace(',', '.'));
        const ml = /^л(?:$|итр)/iu.test(volume[2]) ? amount * 1_000 : amount;
        return ml > 0 && ml <= 5_000 ? Math.round(ml) : null;
    }
    const glasses = normalized.match(new RegExp(String.raw `(?:(?<![\p{L}\d])(\d+(?:[.,]\d+)?)\s*)?(?<!\p{L})(?:${GLASS.source})(?!\p{L})`, 'iu'));
    if (glasses) {
        const count = glasses[1] ? Number(glasses[1].replace(',', '.')) : 1;
        const ml = count * 250;
        return ml > 0 && ml <= 5_000 ? Math.round(ml) : null;
    }
    // Просто «вода» — одно стандартное добавление, как один стакан.
    return 250;
}
//# sourceMappingURL=water.js.map